// src/stone/icons/ZapOff2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ZapOff2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M22.064 2.416a1 1 0 0 1 .595 1.04l-.983 7.917a1 1 0 0 1-1.985-.246l.563-4.533-1.869 2.246a1 1 0 1 1-1.537-1.28l4.05-4.866a1 1 0 0 1 1.166-.278M25.1 16.667a1 1 0 0 1 1-1H35a1 1 0 0 1 .768 1.64l-4.05 4.85a1 1 0 0 1-1.535-1.281l2.68-3.21H26.1a1 1 0 0 1-1-1M13.974 12.565a1 1 0 0 1 .128 1.409l-6.967 8.36H20a1 1 0 0 1 .992 1.123l-1.243 9.95 6.15-7.38a1 1 0 1 1 1.536 1.28l-8.333 10a1 1 0 0 1-1.76-.764l1.525-12.21H5a1 1 0 0 1-.768-1.64l8.333-10a1 1 0 0 1 1.409-.128" }),
      /* @__PURE__ */ jsx("path", { d: "M.96.96a1 1 0 0 1 1.414 0L39.04 37.626a1 1 0 0 1-1.415 1.414L.96 2.374A1 1 0 0 1 .96.96" })
    ]
  }
);
var ZapOff2X_default = ZapOff2X;

export {
  ZapOff2X,
  ZapOff2X_default
};
